import { map } from './layers-init.js'
import { lightning, weatherTilesGroup, generateTileLayers, activeLayers, clearActiveLayers } from './layers.js'

/*  DATA MANAGEMENT
    The logic below decides how weather layers get refreshed
*/
let refreshDataInterval, checkForActiveLayers, stopDataRefresh, userForceRefreshTimeout
let refreshDataIntervals = []

function checkForNewLayers() {
  // Clear any active layers from memory
  clearActiveLayers()

  // Clear any "Refresh" buttons leftover
  // This often happens when a "Data may be out of date" button is displayed to the user,
  // but the user doesn't click that button and instead toggles on a different weather layer
  const button = document.getElementById('button-data-refresh')
  if (button) {
    button.parentNode.removeChild(button)
  }

  checkForActiveLayers = setInterval(() => {
    // Clear any previous checks for "active layers", as a sanity check
    if (checkForActiveLayers) {
      clearInterval(checkForActiveLayers)
    }
  
    // Clear any refresh intervals that may have been set
    // This often happens if the user had another layer toggled on and switches to a new layer
    if (refreshDataIntervals.length > 0 ) {
      refreshDataIntervals.map(refreshDataInterval => clearInterval(refreshDataInterval))
    }

    // Clear any timeouts that may have been set
    // This often happens if the user had another layer toggled on and switches to a new layer
    if (stopDataRefresh) {
      clearTimeout(stopDataRefresh)
    }

    if (userForceRefreshTimeout) {
      clearTimeout(userForceRefreshTimeout)
    }
    
    // Check to see if the active weather layers are plotted
    // If they are, allow the weather data layers to be refreshed and prevent any more checks
    // If there are no active layers, this code will check again for them again in 10 seconds.
    // After 30 minutes, user will need to initiate a refresh of active layers
    if (activeLayers) {
      activeLayers.map(activeLayer => allowDataRefresh(activeLayer))
      clearInterval(checkForActiveLayers)
      userForceRefresh(activeLayers)
    }
  }, 10000)
}

function allowDataRefresh(activeLayer) {
  refreshDataInterval = setInterval(() => {
    clearActiveLayers()
    map.removeLayer(weatherTilesGroup)
    lightning.clearLayers()
    
    generateTileLayers([activeLayer])

  }, 1000 * 60 * activeLayer.interval)

  refreshDataIntervals.push(refreshDataInterval)

  // Regardless of each weather layers refresh interval, clear all weather layer intervals after a period of 30 minutes
  // Call a function that displays a message to the user saying the data is out of date 
  stopDataRefresh = setTimeout(() => {
    refreshDataIntervals.map(refreshDataInterval => clearInterval(refreshDataInterval))
  }, 1000 * 60 * 31)
}

/* HANDLE REFRESH SCENARIO WITHIN THE UI */
function userForceRefresh(activeLayers) {
  userForceRefreshTimeout = setTimeout(() => {
    // Build, style, and place the button in the DOM
    let button = document.createElement('button')
    button.innerHTML = 'Click here to refresh map data.'
    button.setAttribute('id', 'button-data-refresh')
    button.style.cssText = `
      font-size: 1rem;
      font-weight: bold;
      padding: 0.4rem;
      background: gold;
      border: none;
      border-radius: 0px;
    `
    document.getElementById('data-refresh').appendChild(button)

    document.getElementById('button-data-refresh').addEventListener('click', (evt) => {
      // Remove "Refresh" button from the UI
      const button = document.getElementById('button-data-refresh')
      if (button.parentNode) {
        button.parentNode.removeChild(button)
      }

      // Clear any refresh intervals that may have been set
      if (refreshDataIntervals.length > 0 ) {
        refreshDataIntervals.map(refreshDataInterval => clearInterval(refreshDataInterval))
      }

      // Clear any timeouts that may have been set
      if (stopDataRefresh) {
        clearTimeout(stopDataRefresh)
      }

      // Remove old weather data
      map.removeLayer(weatherTilesGroup)
      lightning.clearLayers()

      // Reload the active layers
      checkForNewLayers()
      generateTileLayers(activeLayers)
    })
  }, 1000 * 60 * 31)
}

export { checkForNewLayers }